import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import AddCourseCategory from "../components/AddCourseCategory";

const AddCourseCategoryPage = () => {
  return (
    <>

  
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Add Level  </h5><Breadcrumb title="Add Level" /></div>

        {/* AddUserLayer */}
        <AddCourseCategory />

    </>
  );
};

export default AddCourseCategoryPage;
